import { all, fork } from "redux-saga/effects";
import { initialiseFirebase } from "./initialiseFirebase";
import { authentication } from "./authentication";
import { logError, watchLogError } from "./loggers";
import { watchUserFoundThen } from "./shared";
import { initializeNotifications } from "./notifications/initializeNotifications";
import { watchNotificationRequest } from "./notifications/request";
import { watchUserThenListenPermissions } from "./firebaseDataSync/permissions";
import { watchUserThenListencurrentUser } from "./firebaseDataSync/currentUser";
import { watchUserThenListenOnUserSubjects } from "./firebaseDataSync/userSubjects";
import { watchUserThenListenOnArticles } from "./firebaseDataSync/articles";

const rootSaga = function*() {
    try {
        yield watchLogError;

        yield initialiseFirebase();

        yield fork(all, [
            authentication({ paths: { afterRegistration: "/interests" } }),
            watchUserThenListenPermissions,
            watchUserThenListencurrentUser,
            watchUserFoundThen(initializeNotifications),
            watchNotificationRequest,
            watchUserThenListenOnUserSubjects,
            watchUserThenListenOnArticles
        ]);
    } catch (e) {
        yield logError(e);
        window.location.reload(); // TODO: redirect to error page?
    }
};

export { rootSaga };



// WEBPACK FOOTER //
// ./src/store/sagas/index.js